// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/font-awesome/css/font-awesome.css
// module id = 5W1q
// module chunks = 91